const environment = process.env.REACT_APP_STAGE || 'dev';

const pjson = require('../package.json');

const VERSION = `${pjson.version}.${pjson.sprint}.${
	pjson.build === '0' ? Date.now() : pjson.build
}`;
const RELEASE = pjson.version;

const localIP = '192.168.68.58';

const config: any = {
	mobile: {
		environment,
		release: RELEASE,
		version: VERSION,
		baseUrl: `http://${localIP}:3000`,
		apiBaseUrl: `http://${localIP}:8080`,
		googleOAuth: {
			GOOGLE_CLIENT_ID:
				'37450922555-lsd1bmeclf7vr36qb0slqkh3f9970ogf.apps.googleusercontent.com',
			REDIRECT_URI: `http://${localIP}:3000/oauth2callback`,
		},
		stripe: {
			PUBLISHABLE_KEY:
				'pk_test_51RFGZd2aEhjMnGOWhOu5D2VJGIJKAN8Vg6iMO3TR4kfB1Pk2XT5LMHRmGJwblhcV6lYduraMZNjdBLp3nVW53Gs500OCZb60xZ',
		},
	},
	local: {
		environment,
		release: RELEASE,
		version: VERSION,
		baseUrl: 'http://localhost:3000',
		apiBaseUrl: 'http://localhost:8080',
		googleOAuth: {
			GOOGLE_CLIENT_ID:
				'37450922555-lsd1bmeclf7vr36qb0slqkh3f9970ogf.apps.googleusercontent.com',
			REDIRECT_URI: `http://localhost:3000/oauth2callback`,
		},
		stripe: {
			PUBLISHABLE_KEY:
				'pk_test_51RFGZd2aEhjMnGOWhOu5D2VJGIJKAN8Vg6iMO3TR4kfB1Pk2XT5LMHRmGJwblhcV6lYduraMZNjdBLp3nVW53Gs500OCZb60xZ',
		},
	},
	dev: {
		environment,
		release: RELEASE,
		version: VERSION,
		baseUrl: 'https://astrowebs.com',
		apiBaseUrl: 'https://api.astrowebs.com',
		googleOAuth: {
			GOOGLE_CLIENT_ID:
				'37450922555-lsd1bmeclf7vr36qb0slqkh3f9970ogf.apps.googleusercontent.com',
			REDIRECT_URI: `https://astrowebs.com/oauth2callback`,
		},
		stripe: {
			PUBLISHABLE_KEY:
				'pk_test_51RFGZd2aEhjMnGOWhOu5D2VJGIJKAN8Vg6iMO3TR4kfB1Pk2XT5LMHRmGJwblhcV6lYduraMZNjdBLp3nVW53Gs500OCZb60xZ',
		},
	},
	prod: {
		environment,
		release: RELEASE,
		version: VERSION,
		baseUrl: 'https://orbito.app',
		apiBaseUrl: 'https://api.orbito.app',
		googleOAuth: {
			GOOGLE_CLIENT_ID:
				'37450922555-lsd1bmeclf7vr36qb0slqkh3f9970ogf.apps.googleusercontent.com',
			REDIRECT_URI: `https://orbito.app/oauth2callback`,
		},
		stripe: {
			PUBLISHABLE_KEY:
				'pk_live_51QXQnnFQfPoy2YINWBTFneYHVfTA9yLk5sHanT5D86hnqmaG9j2WC0fOH9fZibLbxBGGg8l5S5aiWPBeBJG7ca4E00B6eJ2fkw',
		},
	},
};

export default config[environment];
